import { Card, Divider, Input, Modal, Space, Button, Form } from "antd";
import React, { useState } from "react";
import { useSession } from "../utils/Session";
import { SelectOutlined, DeleteOutlined } from '@ant-design/icons';
import FileBrowser from "./FileBrowser";
import { cacheBuster } from "../utils/Utils";

export default function ImageSelect(props) {

    const { video = false, onAlt = () => { }, onChange = () => { }, width = 250, height = 100, require_alt = false, alt = "", alt_name = "" } = props;
    const [visible, setVisible] = useState(false);
    const [path, setPath] = useState({ path: (props.path) ? props.path : "" });
    const [session, setSession] = useSession();

    const selectImage = (_image) => {
        if (require_alt && _image) {
            return selectAlt(_image);
        } else {
            setPath(_image);
            onChange((_image.path) ? _image.path : "");
            setVisible(false);
        }
    }

    const selectAlt = (_image) => {

        

        setVisible(false);
        let alt_text = alt;
        const handleInputChange = (e) => {
            alt_text = e.target.value;
        };

        Modal.info({
            icon: <></>,
            title: "Please enter alt text",
            content: <>
                <Divider style={{"margin" : "15px 0px"}} dashed />
                <Form layout="vertical">
                    <Form.Item name="alt" label="Alt text" rules={[{required : true, message : "Alt text is required"}]}>
                    <Input placeholder="Alt text..." defaultValue={alt} onChange={handleInputChange} />
                    </Form.Item>
                </Form>
            </>,
            okText: "",
            onOk: () => {
                setPath(_image);
                onChange(_image.path, alt_text);
            }
        })

    }


    return (
        <>
            <Modal title="Media Gallery" footer={null} width={1000} open={visible} onCancel={() => setVisible(false)}>
                <FileBrowser video={video} selectImage={selectImage} />
            </Modal>

            {(!video && <>
                <Space>
                    <Card bodyStyle={{ "padding": "5px" }} className="img-pattern-dark" >
                        <div style={{ "minHeight": "50px", "width": width + "px", "height": height + "px", "display": "flex", "alignContent": "center", "backgroundRepeat": "no-repeat", "backgroundPosition": "center", "backgroundSize": "contain", "backgroundImage": (path.path) ? "url('https://bookmanager.com/i/" + session.webstore_name + path.path + cacheBuster() + "')" : "none" }}>
                            <div>

                            </div>
                        </div>
                    </Card>
                </Space>
            </>)}

            {(video && <>
                <Input disabled={true} value={path.path} />
            </>)}

            <div className="shim" />
            <div className="float-flex">
                <div></div>
                <Space size={3}>
                    <Button type="primary" onClick={() => setVisible(true)} size="small"><small><SelectOutlined />&nbsp;Select</small></Button>
                    {(path.path && <Button type="primary" danger onClick={() => selectImage("")} size="small"><small><DeleteOutlined />&nbsp;Remove</small></Button>)}
                </Space>
            </div>

            <div className="shim" />
        </>
    )
}